import { User } from 'able-lib'

export interface UserStateInterface {
  user: User;
  users: Array<User>;
  roles: Array<any>;
  locations: Array<any>;
}

export default function (): UserStateInterface {
  return {
    user: null,
    users: [],
    roles: [],
    locations: []
  }
}
